import React, { useEffect } from 'react';
import { Chart, Line } from 'react-chartjs-2';
import getIsMobile from 'components/atoms/utils/getIsMobile';
import { NoGraphDataSvg } from 'components/icons';
import { useTheme } from "styled-components";
import annotationPlugin from 'chartjs-plugin-annotation';


const isMobile = getIsMobile();

export const CustomChart = (props) => {
  const { color, avgColor, graphData, onElementClick, height, multiple, title } = props;
  const theme = useTheme();

  let chartReference = {};
  
  
  useEffect(() => {    

    if(graphData.average !== undefined){
      chartReference.chartInstance.annotation.elements['a-line-1'].options.value = graphData.average;
      chartReference.chartInstance.annotation.elements['a-line-1'].options.label.content = 'Avg ' + graphData.average;
      chartReference.chartInstance.annotation.elements['a-line-1'].options.label.backgroundColor = avgColor,
      chartReference.chartInstance.annotation.elements['a-line-1'].options.borderColor = avgColor;
      chartReference.chartInstance.annotation.elements['a-line-1'].options.label.enabled = true 

      graphData.average <= 5 
    ? chartReference.chartInstance.annotation.elements['a-line-1'].options.label.yAdjust = -10
    : chartReference.chartInstance.annotation.elements['a-line-1'].options.label.yAdjust = 0
    // have to use else if statement in the event a different chart is called which doesnt have the annotation array/object. shouldnt effect that code 
    } else if(chartReference.chartInstance.annotation.elements['a-line-1']){
      chartReference.chartInstance.annotation.elements['a-line-1'].options.value = -1;
        chartReference.chartInstance.annotation.elements['a-line-1'].options.label.enabled = false 
        chartReference.chartInstance.annotation.elements['a-line-1'].options.borderColor = '#FFFFFF';
    }
    
    
    Chart.pluginService.register({annotationPlugin})
    Chart.pluginService.register({
      afterDraw: function (chart, easing) {
        if (chart.tooltip._active && chart.tooltip._active.length) {
          const activePoint = chart.controller.tooltip._active[0];
          const ctx = chart.ctx;
          const x = activePoint.tooltipPosition().x;
          const topY = activePoint.tooltipPosition().y;
          const bottomY = chart.scales['y-axis-0'].bottom;

          ctx.save();
          ctx.beginPath();
          ctx.setLineDash([10, 10]);
          ctx.moveTo(x, topY);
          ctx.lineTo(x, bottomY);
          ctx.lineWidth = 2;
          ctx.strokeStyle = color;
          ctx.stroke();
          ctx.restore();
        } 
      }
    });
  }, [color,graphData.average])

  let tooltipTitle = '';
  if (graphData.title === 'assigned') {
    tooltipTitle = 'Orders Assigned';
  }
  if (graphData.title === 'completed') {
    tooltipTitle = 'Orders Completed';
  }
  if (graphData.title === 'withdrawn') {
    tooltipTitle = 'Orders Withdrawn';
  }
  if (graphData.title === 'callback') {
    tooltipTitle = 'Callbacks';
  }

  const options = {
    scales: {
      yAxes: [{
        type: 'linear',
        gridLines: {
          drawTicks: false,
        },
        ticks: {
          fontColor: "#9EACB0",
          min: 0,
          stepSize: graphData?.stepSize ? graphData.stepSize : 40 ,
          suggestedMax: graphData?.maxsize ? graphData.maxsize : 120,
        }
      }],
      xAxes: [{
        gridLines: {
          display: false,
        },
        ticks: {
          fontColor: "#9EACB0",
        }
      }]
    },
    legend: {
      display: false,
    },
    annotation: {
      annotations: [
      {
          display: graphData.average ? true :false,
          id: "a-line-1",
          type: "line",
          mode: "horizontal",
          scaleID: "y-axis-0",
          label: {
          enabled: true,
          backgroundColor:`${avgColor}`,
          position:'right',
          cornerRadius: 15,
          xPadding:10,
          yPadding:6,
          fontFamily: "Archia",
          fontSize: 16,
          fontStyle:'regular',
        },
        value:graphData.average,
        borderDash: [6, 6],
        borderDashOffset: 0,
        borderWidth: 1.5,
        borderColor:avgColor,
        },
      ],
    
    },
    onClick: function (evt, element) {
      onElementClick(element[0]?._index ?? -1)
    },

    onHover: (event, chartElement) => {
      event.target.style.cursor = chartElement[0] ? 'pointer' : 'default';
    },
    tooltips: {
      titleFontSize: 12,
      mode: 'nearest',
      intersect: false,
      axis: 'x',
      xPadding: 10,
      callbacks: {
        title: (item, data) => {
          return `${item[0].value} ${tooltipTitle}`
        },
        label: () => {
          return null
        }
      }
    },
  }



  function multioptions(title) {
    return {
      plugins: {
        labels: {
          render: "label",
        },
      },
      title: {
        display: false,
        text: title,
      },
      scales: {
        yAxes: [{
          type: 'linear',
          gridLines: {
            drawTicks: false,
          },
          ticks: {
            fontColor: "#9EACB0",
            min: 0,
            stepSize: graphData?.stepSize ? graphData.stepSize : 40 ,
            suggestedMax: graphData?.maxsize ? graphData.maxsize : 120,
          }
        }],
        xAxes: [{
          gridLines: {
            display: false,
          },
          ticks: {
            fontColor: "#9EACB0",
          }
        }]
      },
    };
  }

  const chart = (canvas) => {

    const ctx = canvas.getContext("2d");
    const gradient = ctx.createLinearGradient(0, 0, 0, canvas.height);
    gradient.addColorStop(0, `${color}B3`);
    gradient.addColorStop(1, `${color}00`);

    return {
      labels: graphData.labels,
      datasets: [{
        label:'graph',
        data: graphData.data,
        backgroundColor: gradient,
        borderColor: `${color}80`,
        pointHoverRadius: 8,
        pointBackgroundColor: `${color}80`,
        pointHoverBorderColor: '#FFFFFF',
        pointHoverBorderWidth: 4,
      }]
    }
  }
 
 
  const multiChart = (canvas) => {
    if (graphData.data.length === 1) {
      const ctx = canvas.getContext("2d");
      const gradient = ctx.createLinearGradient(0, 0, 0, canvas.height);
      gradient.addColorStop(0, theme?.colour?.primary);
      gradient.addColorStop(1, `${theme?.colour?.primary}00`);
      return {
        labels: graphData.labels,
        datasets: [{
          ...graphData.data[0],
          backgroundColor: gradient,
          borderColor: theme?.colour?.primary,
          pointColor: "#fff",
          pointStrokeColor: theme?.colour?.primary,
          pointHighlightFill: "#fff",
          pointHighlightStroke: theme?.colour?.primary,
        }]
      }
    } else {
      return {
        labels: graphData.labels,
        datasets: graphData.data
      };
    }
  }
  return (
    <div className="w-full h-full relative" >
      <Line ref={(reference) => chartReference = reference} data={multiple ? multiChart : chart} height={isMobile ? 170 : height ? height : 80} options={multiple ? multioptions(title) : options} />
      {graphData.data.length === 0 &&
        <div className='absolute flex left-0 right-0 top-0 bottom-0 items-center justify-center'>
          <NoGraphDataSvg />
        </div>
      }
    </div >
  )
}
